<template lang="pug">
    b-alert.alertme(v-model='alert.message != null', dismissible)
      b-container
        .row(v-if="alert.type==='alert-success'")
          .col-3.d-flex.align-items-center.justify-content-center
            i.fa.fa-check
          .col-9.p-0
            h4.m-0 Success
            p.m-0 {{ alert.message }}
        .row(v-else-if="alert.type==='alert-danger'")
          .col-3.d-flex.align-items-center.justify-content-center
            i.fa.fa-times
          .col-9
            h4.m-0 Error
            p.m-0 {{ alert.message }}
        .row(v-else="")
          .col-3.d-flex.align-items-center.justify-content-center
            i.fa.fa-envelope
          .col-9
            h4.m-0 Message
            p.m-0 {{ alert.message }}
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'alert',
  data() {
    return {

    };
  },
  computed: {
    ...mapState('alert', ['alert']),
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
  .alertme{
    color: black;
    border: none;
    border-radius: 0;
    border-left: 10px solid rgba(black, 0.9);
    background-color: white;
    z-index: 100000000;
    position: fixed;
    top: 10px;
    right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/AlertPop.vue